import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {AlertController, Platform} from '@ionic/angular';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';

import {LanguageService} from './provider/language.service';
import {Storage} from '@capacitor/storage';

import {FaIconLibrary} from '@fortawesome/angular-fontawesome';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {far} from '@fortawesome/free-regular-svg-icons';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedNavigationService} from "./shared/_services/sharednavigation.service";

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
    public session_expiry: string = '';
    public key: any = null;

    constructor(
        private _location: Location,
        protected activatedRoute: ActivatedRoute,
        private platform: Platform,
        public alertController: AlertController,
        public translate: TranslateService,
        private languageservice: LanguageService,
        private navigationService: SharedNavigationService,
        private router: Router,
        library: FaIconLibrary
    ) {
        setTimeout(async () => {
            const { value } = await Storage.get({ key: 'appLaunch' });
            if (value == null) {
                // first launch logic if needed
            }
        }, 0);

        this.languageservice.setInitialLang();
        library.addIconPacks(fas, fab, far);
    }

    ngOnInit() {
        // Try to get key from child route if available
        setTimeout(() => {
            this.key = this.activatedRoute.firstChild?.snapshot.paramMap.get('key');
            console.log('Reset/activate key:', this.key);

            this.session_expiry = localStorage.getItem('session_details');
            this.checkSession();
        }, 0);
    }

    public checkSession(): void {
        const currentUrl = this.router.url;

        // ✅ Allow public routes without forcing login
        if (
            currentUrl.startsWith('/authentication/reset') ||
            currentUrl.startsWith('/authentication/activate') ||
            currentUrl.startsWith('/authentication/forgot') ||
            currentUrl.startsWith('/authentication/signup') ||
            currentUrl.startsWith('/authentication/login')
        ) {
            return; // skip session check on public routes
        }

        const session = localStorage.getItem('session_details');

        if (!session) {
            this.clearSession();
            this.router.navigate(['/authentication/login']);
            return;
        }

        if (this.session_expiry && this.session_expiry !== 'undefined') {
            const currentTime = Date.now();
            const expiryStr = this.session_expiry.includes(' ')
                ? this.session_expiry.replace(' ', 'T')
                : this.session_expiry;

            const expiryTime = new Date(expiryStr).getTime();

            if (currentTime > expiryTime) {
                this.clearSession();
                this.router.navigate(['/authentication/login']);
            }
        }
    }

    private clearSession(): void {
        localStorage.removeItem('session_details');
        localStorage.removeItem('authentication-token');
        localStorage.removeItem('user');
    }
}
